/**
 * Achievement Animation Constants
 * Shared constants for achievement animation across components
 */

export const BADGE_SIZE_PX = 140 // Approximate badge width
export const GAP_PX = 16 // Gap between badges
export const STEP_SIZE = BADGE_SIZE_PX + GAP_PX - 48 // 108px (adjusted for proper spacing)
export const ELEVATION_PX = -300 // Move up to center of viewport when selected (negative Y - larger value to reach center)
export const CENTER_SCALE = 1.4 // Scale up when in center
export const TRANSITION_DURATION = '0.4s'
export const MAX_VISIBLE_ACHIEVEMENTS = 4 // Maximum achievements to show at once
